module.exports = __webpack_public_path__ + "img/proj4.d55295c0.png";